<template>
  <form :id="`frm-${id}`" class="px-3" method="post" @submit.prevent="saveFiles">
    <div
      aria-hidden="true"
      aria-labelledby="fileModalTitle"
      class="modal fade file-modal"
      :id="id"
      role="dialog"
      tabindex="-1">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header modal-body-scrolled pb-0">
            <h5 class="modal-title" id="exampleModalLongTitle">{{ title }}</h5>
          </div>
          
          <div class="modal-body overflow-x-hidden">
            <p v-if="message">{{ message }}</p>
            
            <div class="form-group row">
              <div class="card card-fluid shadow-none w-100 mb-0">
                <div class="card-body">
                  
                  <div>
                    <label v-if="multiple">Seleccione los archivos deseados</label>
                    <label v-else>Seleccione el archivo</label>
                    <div class="custom-file">
                      <input type="file"
                             class="custom-file-input"
                             id="upload-file"
                             :multiple="multiple"
                             @change="filesSelected"
                             accept="application/pdf"
                             ref="files">
                      
                      <label class="custom-file-label" for="upload-file">
                        Seleccionar archivo{{ multiple ? 's' : '' }}</label>
                    </div>
                  </div>
                </div>
                
                <hr v-if="sending || selectedFiles.length">
                
                <div id="progress" class="progress progress-xs rounded-0 fade" v-if="sending">
                  <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
                       aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <div id="uploadList" class="list-group list-group-flush list-group-divider" v-if="selectedFiles.length">
                  <div class="list-group-item" v-for="file in selectedFiles"
                       :key="file.id">
                    <div class="list-group-item-figure">
                      <div class="tile tile-img">
                        <span class="fas fa-file-pdf fa-lg text-red"></span>
                      </div>
                    </div>
                    <div class="list-group-item-body">
                      <div class="media align-items-center">
                        <div class="media-body">
                          <a target="_blank"
                             href="#" @click.prevent="">{{ file.name }}</a>
                          <small class="text-muted d-block">{{ fileSize(file) }}</small>
                        </div>
                        <div class="media-actions">
                          <button class="btn btn-sm btn-secondary" type="button" @click="removeFile(file)">Eliminar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="modal-footer flex px-2 shadow-none">
            <button class="btn btn-primary mr-2"
                    type="button"
                    :disabled="selectedFiles.length === 0 || sending"
                    @click.prevent="saveFiles">
              <span class="spinner-border text-yellow-500 spinner-border-sm" role="status" v-if="sending">
                <span class="sr-only">Guardando...</span>
              </span>
              Adjuntar
            </button>
            
            <button class="btn btn-secondary"
                    type="button"
                    :disabled="sending"
                    @click.prevent="closeDialog">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import { AlertManager } from '../utils/AlertManager'
  import { findIndex } from 'lodash'
  
  export default {
    name: 'FileModal',
    props: {
      message: String,
      title: {
        type: String,
        default: 'Adjuntar archivo',
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      id: {
        type: String,
        default: Math.guid(),
      },
      saveFilesFunction: {
        type: Function,
        default: null,
      },
    },
    data() {
      return {
        sending: false,
        selectedFiles: [],
      }
    },
    methods: {
      filesSelected(e) {
        const files = e.target.files
        
        Array.from(files).forEach(file => {
          if(file.type && file.type.toLowerCase().indexOf('pdf') === -1) {
            AlertManager.error(`El formato del archivo ${file.name} no es aceptado. Seleccione un archivo PDF`, {
              timeout: 10000,
            })
            
            return false
          }
          
          if (!this.checkFileSize(file)) {
            AlertManager.error('El tamaño máximo de archivo es de 4MB')
            
            return
          }
          
          if(!this.checkFileType(file)) {
            AlertManager.error('Seleccione un archivo PDF.')
            
            return
          }
          
          this.addFile(file)
        })
      },
      addFile(file) {
        const { name, type, size } = file
        
        $(this.$refs.files).val('')
        
        if(this.multiple) {
          this.selectedFiles.push({
            id: Math.guid(),
            name,
            type,
            size,
            file,
          })
        }
        else {
          this.selectedFiles = [{
            id: Math.guid(),
            name,
            type,
            size,
            file,
          }]
        }
      },
      async saveFiles() {
        if(!this.saveFilesFunction) {
          throw new Error('Save function not defined')
        }
        
        this.sending = true
        
        let response
        
        try {
          response = await this.saveFilesFunction(this.selectedFiles)
        }
        catch (e) {
          this.sending = false
        }
        
        this.sending = false
        
        this.clearDialog()
        
        return response
      },
      fileSize(file) {
        if((file.size / 1024) < 1024) {
          return `${Math.ceil(file.size / 1024)} KB`
        }
        
        return `${Math.ceil(file.size / 1024 / 1024)} MB`
      },
      removeFile(file) {
        const index = findIndex(this.selectedFiles, ['id', file.id])
        
        if(index !== -1) {
          this.selectedFiles.splice(index, 1)
          
          AlertManager.success(`Archivo ${file.name} eliminado satisfactoriamente`)
        }
      },
      closeDialog() {
        this.clearDialog()
        
        $(`#${this.id}`).modal('hide')
      },
      clearDialog() {
        $(this.$refs.files).val('')
        
        this.selectedFiles = []
      },
      checkFileSize(file) {
        let maxFileSize = 4 * 1024 * 1024 // 4MB
        
        const fileSize  = file.size
        
        return fileSize <= maxFileSize;
      },
      checkFileType(file) {
        const extension = file.name.slice((Math.max(0, file.name.lastIndexOf('.')) || Infinity) + 1)
        
        return !(extension && extension.toLowerCase() !== 'pdf');
      },
    },
  }
</script>
